// local imports
import { newsletter } from "../data";
import { config } from "../config";
import { useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('success');
  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();

    // Validate email first
    if (!validateEmail(email)) {
      setPopupMessage('Please enter a valid email address');
      setPopupType('error');
      setShowPopup(true);
      return;
    }

    setLoading(true);

    try {
      await fetch(config.GOOGLE_APPS_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors', // Google Apps Script doesn't support CORS
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'subscribe',
          email: email
        })
      });

      // Since no-cors mode is used, we can't read the response
      // We'll assume success if no error is thrown
      setPopupMessage('Thank you! You\'ve been successfully subscribed to our course updates.');
      setPopupType('success');
      setShowPopup(true);
      setEmail('');
    } catch (error) {
      console.error('Error subscribing email:', error);
      setPopupMessage('Sorry, there was an error. Please try again.');
      setPopupType('error');
      setShowPopup(true);
    } finally {
      setLoading(false);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // Handle location click to open Google Maps
  const handleLocationClick = () => {
    const address = "BIM BYTES ACADEMY, Chennai";
    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <footer className="relative bg-gradient-to-br from-dark via-secondary to-dark text-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="container-width py-12 relative z-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 mb-16">
          {/* Newsletter Section */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                {newsletter}
              </h2>
              <div className="w-20 h-1 bg-gradient-to-r from-primary to-accent rounded-full"></div>
            </div>

            <p className="text-gray-300 text-lg leading-relaxed max-w-md">
              Stay updated with our latest BIM training programs, industry insights, and career opportunities.
            </p>

            <form onSubmit={handleSubscribe} className="space-y-4">
              <div className="relative group">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  className="w-full px-6 py-4 bg-white/10 border border-white/20 text-white placeholder-gray-400 
                           rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent 
                           transition-all duration-300 ease-smooth backdrop-blur-sm
                           group-hover:bg-white/15 group-hover:border-white/30"
                  required
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="absolute right-2 top-1/2 -translate-y-1/2 px-6 py-2.5 
                           bg-gradient-to-r from-primary to-accent hover:from-primary/90 hover:to-accent/90
                           text-white font-semibold rounded-lg transition-all duration-300 ease-smooth
                           transform hover:scale-105 shadow-lg hover:shadow-glow disabled:opacity-50 disabled:cursor-not-allowed">
                  {loading ? 'Subscribing...' : 'Subscribe'}
                </button>
              </div>
              <p className="text-xs text-gray-400">
                We respect your privacy. Unsubscribe at any time.
              </p>
            </form>
          </div>

          {/* Links Section - Three Columns */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Company */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-white relative">
                Company
                <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-primary to-accent rounded-full"></div>
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-gray-300 hover:text-primary transition-all duration-300 ease-smooth text-sm
                             relative group text-left w-full block"
                  >
                    <span className="relative">
                      About Us
                      <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-300 ease-smooth group-hover:w-full"></span>
                    </span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/placement"
                    className="text-gray-300 hover:text-primary transition-all duration-300 ease-smooth text-sm
                             relative group text-left w-full block"
                  >
                    <span className="relative">
                      Placement & Internships
                      <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-300 ease-smooth group-hover:w-full"></span>
                    </span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blog"
                    className="text-gray-300 hover:text-primary transition-all duration-300 ease-smooth text-sm
                             relative group text-left w-full block"
                  >
                    <span className="relative">
                      Blog
                      <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-300 ease-smooth group-hover:w-full"></span>
                    </span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-gray-300 hover:text-primary transition-all duration-300 ease-smooth text-sm
                             relative group text-left w-full block"
                  >
                    <span className="relative">
                      Contact
                      <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-300 ease-smooth group-hover:w-full"></span>
                    </span>
                  </Link>
                </li>
              </ul>
            </div>

            {/* Courses Column */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-white relative">
                Courses
                <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-primary to-accent rounded-full"></div>
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/courses" className="text-gray-300 hover:text-primary text-sm hover:underline">BIM Coordinator Course</Link>
                </li>
                <li>
                  <Link to="/courses" className="text-gray-300 hover:text-primary text-sm hover:underline">BIM Manager Course</Link>
                </li>
                <li>
                  <Link to="/courses" className="text-gray-300 hover:text-primary text-sm hover:underline">MEP Modeler Course</Link>
                </li>
                <li>
                  <Link to="/courses" className="text-gray-300 hover:text-primary text-sm hover:underline">View All Courses →</Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-white relative">
                Contact Info
                <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-primary to-accent rounded-full"></div>
              </h3>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={handleLocationClick}
                    className="text-gray-300 hover:text-primary transition-all duration-300 ease-smooth text-sm cursor-pointer hover:underline text-left block w-full"
                  >
                    BimBytes Academy, Avadi
                  </button>
                </li>
                <li>
                  <a
                    href="mailto:info@bimbytesacademy.com"
                    className="text-gray-300 hover:text-primary transition-all duration-300 ease-smooth text-sm hover:underline"
                  >
                    info@bimbytesacademy.com
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+918807740059"
                    className="text-gray-300 hover:text-primary transition-all duration-300 ease-smooth text-sm hover:underline"
                  >
                    +91 88077 40059
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider with Gradient */}
        <div className="relative mb-8">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div className="w-4 h-4 bg-gradient-to-r from-primary to-accent rounded-full"></div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          {/* Copyright */}
          <div className="text-center md:text-left">
            <p className="text-gray-400 text-sm">
              &copy; 2025 <span className="text-primary font-semibold">BimBytes Academy</span> - All rights reserved.
            </p>
            <p className="text-gray-500 text-xs mt-1">
              Transforming careers through BIM excellence.
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center justify-center md:justify-end gap-5">
            <a href="https://www.linkedin.com/company/bim-bytes-solutions/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="group text-white/80 hover:text-white transition flex items-center justify-center shrink-0 w-5 h-5">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>

            <a href="https://www.instagram.com/bimbytesacademy?igsh=M2RuZXkyYjZqZWdl" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="group text-white/80 hover:text-white transition flex items-center justify-center shrink-0 w-5 h-5">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5">
                <path d="M7.75 2C4.686 2 2 4.686 2 7.75v8.5C2 19.314 4.686 22 7.75 22h8.5c3.064 0 5.75-2.686 5.75-5.75v-8.5C22 4.686 19.314 2 16.25 2h-8.5zm0 2h8.5c1.93 0 3.75 1.82 3.75 3.75v8.5c0 1.93-1.82 3.75-3.75 3.75h-8.5C5.82 20 4 18.18 4 16.25v-8.5C4 5.82 5.82 4 7.75 4zm8.75 1.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z" />
              </svg>
            </a>

            <a href="https://x.com/bimbytesacademy?s=21" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="group text-white/80 hover:text-white transition flex items-center justify-center shrink-0 w-5 h-5">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5">
                <path d="M18.244 2H21l-6.56 7.497L22 22h-6.828l-5.35-7.007L3.78 22H1l7.043-8.05L2 2h6.828l4.89 6.438L18.244 2zm-1.2 18h1.8L7.04 4H5.18l11.864 16z" />
              </svg>
            </a>
            <a href="https://www.facebook.com/share/17YWuZ9nsT/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="group text-white/80 hover:text-white transition flex items-center justify-center shrink-0 w-5 h-5">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5">
                <path d="M22 12a10 10 0 10-11.5 9.9v-7H7v-3h3.5V9.5c0-3.5 2.1-5.4 5.2-5.4 1.5 0 3.1.3 3.1.3v3.4h-1.8c-1.8 0-2.3 1.1-2.3 2.2V12H19l-.6 3h-3.7v7A10 10 0 0022 12z" />
              </svg>
            </a>

            <a href="https://wa.me/918807740059" aria-label="WhatsApp" className="group text-white/80 hover:text-white transition flex items-center justify-center shrink-0 w-5 h-5">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
              </svg>
            </a>
            <a href="https://www.youtube.com/@BimBytesAcademy" aria-label="YouTube" className="group text-white/80 hover:text-white transition flex items-center justify-center shrink-0 w-5 h-5">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path d="M23.5 6.2a3 3 0 00-2.1-2.1C19.6 3.5 12 3.5 12 3.5s-7.6 0-9.4.6A3 3 0 00.5 6.2 31.2 31.2 0 000 12a31.2 31.2 0 00.5 5.8 3 3 0 002.1 2.1c1.8.6 9.4.6 9.4.6s7.6 0 9.4-.6a3 3 0 002.1-2.1A31.2 31.2 0 0024 12a31.2 31.2 0 00-.5-5.8zM9.8 15.5v-7l6.3 3.5-6.3 3.5z" />
              </svg>
            </a>
          </div>

          <div className="text-center md:text-right">
            <span className="text-gray-400 text-xs">
              Designed &amp; Developed by{" "}
              <a
                href="https://www.mmlsoftware.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary font-semibold hover:underline"
              >
                MML Software Solutions
              </a>
            </span>
          </div>
        </div>
      </div>

      {/* Bottom Accent */}
      <div className="h-1 bg-gradient-to-r from-primary via-accent to-secondary"></div>

      {/* Popup Notification */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className={`bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl transform transition-all duration-300 ${showPopup ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
            }`}>
            <div className="text-center">
              <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${popupType === 'success' ? 'bg-green-100' : 'bg-red-100'
                }`}>
                {popupType === 'success' ? (
                  <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                )}
              </div>

              <h3 className={`text-lg font-semibold mb-2 ${popupType === 'success' ? 'text-green-800' : 'text-red-800'
                }`}>
                {popupType === 'success' ? 'Success!' : 'Error'}
              </h3>

              <p className={`text-sm mb-6 ${popupType === 'success' ? 'text-green-600' : 'text-red-600'
                }`}>
                {popupMessage}
              </p>

              <button
                onClick={closePopup}
                className={`px-6 py-2 rounded-xl font-medium transition-colors ${popupType === 'success'
                    ? 'bg-green-600 text-white hover:bg-green-700'
                    : 'bg-red-600 text-white hover:bg-red-700'
                  }`}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
